import React from 'react';
import { Container } from 'styles/pages/orders/orderFilter';
import Button from 'components/Button';

const OrderFilter = ({
  updateCategory,
  selected,
  orderCounts = {},
  rowsSelected,
  payButtonClick,
  paymentSkip,
  handleVendorsReferenceClick,
}) => (
  <div style={{ display: 'flex' }}>
    <Container>
      <div
        className={selected === 'PendingDetails' ? 'selected' : ''}
        onClick={() => updateCategory('PendingDetails')}
      >
        Pending Details<span>{orderCounts.PendingDetails || 0}</span>
      </div>
      <div
        className={selected === 'AwaitingPayment' ? 'selected' : ''}
        onClick={() => updateCategory('AwaitingPayment')}
      >
        Awaiting Payment<span>{orderCounts.AwaitingPayment || 0}</span>
      </div>
      <div
        className={selected === 'InProduction' ? 'selected' : ''}
        onClick={() => updateCategory('InProduction')}
      >
        In Production<span>{orderCounts.InProduction || 0}</span>
      </div>
      <div
        className={selected === 'Shipped' ? 'selected' : ''}
        onClick={() => updateCategory('Shipped')}
      >
        Shipped<span>{orderCounts.Shipped || 0}</span>
      </div>
      <div
        className={selected === 'Cancelled' ? 'selected' : ''}
        onClick={() => updateCategory('Cancelled')}
      >
        Cancelled<span>{orderCounts.Cancelled || 0}</span>
      </div>
    </Container>
    {/* <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'flex-end',
      }}>
      {selected === 'AwaitingPayment' && (
        <Button
          title={
            paymentSkip === true ? 'Submit Order(s)' : 'Pay & Submit Order(s)'
          }
          disabled={!rowsSelected}
          onClick={payButtonClick}
          containerStyle={{
            backgroundColor: 'rgb(0, 0, 0)',
            color: 'rgb(255, 255, 255)',
            opacity: rowsSelected ? 1 : 0.4,
            height: 34,
            width: paymentSkip === true ? 230 : 260,
            fontWeight: 'bolder',
            fontSize: 17,
          }}
        />
      )}
    </div> */}

    {(selected === 'InProduction' || selected === 'AwaitingPayment') && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          justifyContent: 'flex-end',
        }}
      >
        <Button
          title="Vendors Reference"
          disabled={!rowsSelected}
          onClick={handleVendorsReferenceClick}
          containerStyle={{
            backgroundColor: 'rgb(0, 0, 0)',
            color: 'rgb(255, 255, 255)',
            opacity: rowsSelected ? 1 : 0.4,
          }}
        />
      </div>
    )}
  </div>
);

export default OrderFilter;
